import { Aggregation } from '@vue-storefront/magento-types';

import type { Pagination } from '~/composables/types';
import { perPageOptions } from '~/modules/catalog/category/composables/useFacet/perPageOptions';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import type { UseFacetSearchResult } from '~/modules/catalog/category/composables/useFacet/useFacet';
import type { ProductInterface } from '~/modules/GraphQL/types';

export interface FacetsGetters {
  getSortOptions: (searchData: UseFacetSearchResult, locale?: string) => SortingModel;
  getProducts: (searchData: UseFacetSearchResult) => ProductInterface[];
  getAggregation: (searchData: UseFacetSearchResult) => Aggregation[];
  getPagination: (searchData: UseFacetSearchResult) => Pagination;
}

const facetGetters: FacetsGetters = {
  getSortOptions(searchData, locale) {
    if (!searchData || !searchData.data || !searchData.data.availableSortingOptions) {
      return {
        options: [],
        selected: '',
      } as SortingModel;
    }

    // api error, waiting for BE to process
    if (locale) {
      const filterOptions =
        locale === 'cn'
          ? searchData.data.availableSortingOptions.filter((option: any) => option.value !== 'price_ASC' && option.value !== 'price_DESC')
          : searchData.data.availableSortingOptions;
      return {
        options: filterOptions,
        selected: searchData.input.sort,
      };
    }
    const filterOptions = searchData.data.availableSortingOptions.filter(
      (option: any) => option.value !== 'price_ASC' && option.value !== 'price_DESC'
    );
    return {
      options: filterOptions,
      selected: searchData.input.sort,
    };
  },
  getAggregation(searchData) {
    if (!searchData || !searchData.data || !searchData.data.aggregations) {
      return [];
    }
    return searchData.data.aggregations;
  },
  getProducts(searchData) {
    if (!searchData || !searchData.data || !searchData.data.items) {
      return [];
    }
    return searchData.data.items;
  },
  getPagination(searchData) {
    // eslint-disable-next-line no-nested-ternary
    const totalPages = searchData?.data
      ? Number.isNaN(Math.ceil(searchData.data.total / searchData.input.itemsPerPage))
        ? 1
        : Math.ceil(searchData.data.total / searchData.input.itemsPerPage)
      : 1;

    return {
      currentPage: (searchData?.input?.page > totalPages ? 1 : searchData?.input?.page) || 1,
      totalPages,
      totalItems: searchData?.data?.total ? searchData.data.total : 0,
      itemsPerPage: searchData?.input?.itemsPerPage || 10,
      pageOptions: perPageOptions,
    };
  },
};

export default facetGetters;
